/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { ChangeAuditPage } from '@/pages/Reports/ChangeAuditPage';

export function ChangeAuditRoute() {
  return <ChangeAuditPage />;
}
